<template>
  <my-dialog
    @hideMask="$emit('update:addOrUpdateOrganizationalDialogFlag', false)"
    :dialogFlag="addOrUpdateOrganizationalDialogFlag"
    width="660px"
    p_lr="0"
    borderRadius="8px"
    :hideMaskFlag="false"
    :clickMaskForHide="true"
  >
    <div class="dialog_container">
      <div class="dialog_container_header">
        <h3 class="header_title">新增机构</h3>
        <div class="close_btn" @click="$emit('update:addOrUpdateOrganizationalDialogFlag', false)">
          <img
            src="//image.zhihuishu.com/zhs/ablecommons/zhangying/202110/322b44f4a1e34d8cb527d1e033ec659b.png"
            alt="关闭"
          />
        </div>
      </div>
      <div class="dialog_container_body">
        <div class="form_item">
          <div class="form_item_title">
            <span class="star">*</span>
            <span>学校ID</span>
          </div>
          <div class="form_item_body">
            <a-input
              v-model:value="schoolCode"
              placeholder="请输入学校ID"
              style="width: 260px; margin-left: 16px"
            ></a-input>
          </div>
        </div>
        <div class="form_item">
          <div class="form_item_title">
            <span class="star">*</span>
            <span>所属省份</span>
          </div>
          <div class="form_item_body">
            <a-select
              default-value=""
              @change="handleProvince"
              placeholder="请选择所属省份"
              style="width: 260px; margin-left: 16px"
            >
              <a-select-option :value="item.key" v-for="item in provinceListAll" :key="item.key">
                {{ item.title }}
              </a-select-option>
            </a-select>
          </div>
        </div>
        <div class="form_item">
          <div class="form_item_title">
            <span class="star">*</span>
            <span>学校名称</span>
          </div>
          <div class="form_item_body">
            <a-input
              v-model:value="schoolName"
              placeholder="请输入学校名称"
              style="width: 260px; margin-left: 16px"
            ></a-input>
          </div>
        </div>
        <div class="form_item">
          <div class="form_item_title">
            <span class="star">*</span>
            <span>学校logo</span>
          </div>
          <div class="form_item_body">
            <a-input
              v-model:value="schoolImg"
              placeholder="请输入logo链接"
              style="width: 260px; margin-left: 16px"
            ></a-input>
          </div>
        </div>
        <div class="form_item">
          <div class="form_item_left">
            <div class="form_item_title">
              <span class="star">*</span>
              <span>开通时间</span>
            </div>
            <div class="form_item_body">
              <a-date-picker
                @change="openingDateChange"
                placeholder="开通时间"
                format="YYYY-MM-DD"
                valueFormat="YYYY-MM-DD"
                v-model="openingDate"
                :allowClear="false"
                style="width: 130px; margin-left: 16px"
              />
            </div>
          </div>
          <div class="form_item_right">
            <div class="form_item_title">
              <span class="star">*</span>
              <span>到期时间</span>
            </div>
            <div class="form_item_body">
              <a-date-picker
                @change="expiredDateChange"
                placeholder="到期时间"
                format="YYYY-MM-DD"
                valueFormat="YYYY-MM-DD"
                v-model="expiredDate"
                :allowClear="false"
                style="width: 130px; margin-left: 16px"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="dialog_container_footer">
        <div class="cancel_btn" @click="handleCancel">取消</div>
        <div class="confirm_btn" @click="handleConfirm">确定</div>
      </div>
    </div>
  </my-dialog>
</template>

<script>
export default {
  name: 'addOrUpdateOrganizational',
  components: {
    'my-dialog': () => import('@/components/my_dialog')
  },
  data() {
    return {
      schoolCode: '',
      provinceId: '',
      schoolName: '',
      schoolImg: '',
      openingDate: '',
      expiredDate: ''
    }
  },
  props: {
    addOrUpdateOrganizationalDialogFlag: {
      type: Boolean,
      default: false
    },
    provinceList: {
      type: Array,
      default: []
    },
    provinceListAll: {
      type: Array,
      default: []
    }
  },
  methods: {
    handleProvince(value) {
      this.provinceId = value
    },
    openingDateChange(date) {
      console.log(date)
    },
    expiredDateChange(date) {
      console.log(date)
    },
    handleCancel() {
      this.schoolCode = this.provinceId = this.schoolName = this.schoolImg = this.openingDate = this.expiredDate = ''
      this.$emit('update:addOrUpdateOrganizationalDialogFlag', false)
    },
    async handleConfirm() {
      try {
        if (!this.schoolCode) return this.$message.error('请输入学校ID')
        if (!this.provinceId) return this.$message.error('请选择所属省份')
        if (!this.schoolName) return this.$message.error('请输入学校名称')
        if (!this.schoolImg) return this.$message.error('请输入logo链接')
        if (!this.openingDate) return this.$message.error('请选择开通时间')
        if (!this.expiredDate) return this.$message.error('请选择到期时间')
        const params = {
          schoolCode: this.schoolCode,
          provinceId: this.provinceId,
          schoolName: this.schoolName,
          schoolImg: this.schoolImg,
          openingDate: this.openingDate,
          expiredDate: this.expiredDate
        }
        const result = await this.$http.schoolCreate(params)
        if (result.code !== 200) return this.$message.error(result.msg)
        const { rt: resultReally } = result
        if (resultReally.resultStatus !== 1)
          return this.$message.error(resultReally.resultMessage || '抱歉，新增机构失败')
        this.$message.success('新增成功')
        this.schoolCode = this.provinceId = this.schoolName = this.schoolImg = this.openingDate = this.expiredDate = ''
        this.$emit('update:addOrUpdateOrganizationalDialogFlag', false)
        this.$emit('getSchoolList')
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog_container {
  .dialog_container_header {
    width: 100%;
    height: 60px;
    border-radius: 8px 8px 0 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px;
    border-bottom: 2px solid #eaeaea;
    .header_title {
      font-size: 16px;
      font-weight: 500;
      color: #1e2228;
    }
    .close_btn {
      width: 12px;
      height: 12px;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
  }
  .dialog_container_body {
    width: 100%;
    height: 488px;
    padding: 30px 60px;
    .form_item {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      .form_item_left,
      .form_item_right {
        display: flex;
        align-items: center;
      }
      .form_item_right {
        margin-left: 30px;
      }
      .form_item_title {
        width: 70px;
        text-align: right;
        .star {
          color: #ff8786;
          margin-right: 5px;
        }
      }
    }
  }
  .dialog_container_footer {
    width: 100%;
    height: auto;
    padding: 20px 0;
    border-top: 2px solid #eaeaea;
    display: flex;
    justify-content: center;
    .cancel_btn,
    .confirm_btn {
      width: 96px;
      height: 40px;
      border-radius: 4px;
      font-size: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      user-select: none;
    }
    .cancel_btn {
      border: 1px solid #5f60d3;
      color: #5f60d3;
      margin-right: 16px;
      &:hover {
        background-color: #f5f5f5;
      }
      &:active {
        background-color: #fff;
      }
    }
    .confirm_btn {
      background-color: #5f60d3;
      color: #fff;
      &:hover {
        background-color: #40419c;
      }
      &:active {
        background-color: #5f60d3;
      }
    }
  }
}
</style>
